import type { PriceId, ProductKind } from '@iheartjane/types';

export const getProductWeightUnit = (
  productType: ProductKind,
  productPriceId: PriceId | 'undefined'
) => {
  return productType === 'flower' &&
    productPriceId !== 'undefined' &&
    productPriceId !== 'each'
    ? 'g'
    : null;
};
